import { render, staticRenderFns } from "./ForBusiness.vue?vue&type=template&id=a4fa67a0&scoped=true&lang=pug&"
import script from "./ForBusiness.vue?vue&type=script&lang=js&"
export * from "./ForBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fa67a0",
  null
  
)

export default component.exports